// extracted by css-extract-rspack-plugin
export default {"cls1":"Carousel-cls1_q4L","cls2":"Carousel-cls2__kO Carousel-cls1_q4L"};